import { render } from "./ExtraInfo.vue?vue&type=template&id=4ef20654"
import script from "./ExtraInfo.vue?vue&type=script&lang=js"
export * from "./ExtraInfo.vue?vue&type=script&lang=js"

import "./ExtraInfo.vue?vue&type=style&index=0&id=4ef20654&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__